module.exports = __webpack_public_path__ + "static/media/click.aac9b3bc.gif";